import { render } from "./PasswordResetRequestView.vue?vue&type=template&id=5cdac188"
import script from "./PasswordResetRequestView.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__